module.exports = __webpack_public_path__ + "img/cadastro-especialista.920ba992.png";